import React from "react";
import { Collapse, Progress } from "antd";
import { byValueDesc } from "../dashboardData";
import {
  ExtraValueText,
  SubFunctionList,
  SubFunctionRow,
  SubFunctionNameText,
  SubFunctionValueText,
} from "../Dashboard.styles";

// Function → Sub-Function drill-down, antd `Collapse` with each sub-function
// row rendered as an antd `Progress` bar. `functions` is the API's
// breakdown.function array: [{ name, value, sub_function: [{ name, value }] }].

const FunctionAccordion = ({ functions, formatter }) => {
  const items = [...(functions || [])].sort(byValueDesc).map((fn) => {
    const subFunctions = [...(fn.sub_function || [])].sort(byValueDesc);
    const maxValue = Math.max(...subFunctions.map((sf) => sf.value), 1);

    return {
      key: fn.name,
      label: fn.name,
      extra: (
        <ExtraValueText strong>
          {formatter(fn.value)}
        </ExtraValueText>
      ),
      children: (
        <SubFunctionList>
          {subFunctions.map((sf) => (
            <div key={sf.name}>
              <SubFunctionRow>
                <SubFunctionNameText>{sf.name}</SubFunctionNameText>
                <SubFunctionValueText>{formatter(sf.value)}</SubFunctionValueText>
              </SubFunctionRow>
              <Progress
                percent={(sf.value / maxValue) * 100}
                showInfo={false}
                strokeColor="#3F88CE"
                trailColor="#F0F1F5"
                strokeLinecap="round"
                size={["100%", 8]}
              />
            </div>
          ))}
        </SubFunctionList>
      ),
    };
  });

  return <Collapse items={items} bordered ghost={false} />;
};

export default FunctionAccordion;
